<lib-auth-login-header [text]="'Log in' | translate"></lib-auth-login-header>
<lib-auth-login
  (credentialsSubmitted)="login($event)"
  [isCodeRequired]="isCodeRequired"
  [resetPasswordLink]="'/reset-password'">
</lib-auth-login>
